import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ListaTipoIdentificacion } from "src/app/components/individual-afiliate-beneficiary/model/tipo-identificacion.enum";
import { environment } from "src/environments/environment";
import { IVI } from "../../enums/rnec/rnec.enum";
import { HttpService } from "../../http/http.service";
import { CGeneralResponse, GeneralResponse } from "../../models/general-response/general-response";
import { Documents } from "../../models/request/documents";
import { DetalleAfiliadoHijo } from "../../models/rnec/detalleAfiliadoHijo";
import { IdentidadPersonaDto } from "../../models/rnec/identidad-persona.dto";
import { RnecResponseDto } from "../../models/rnec/rnec-response.dto";

@Injectable({
  providedIn: "root"
})
export class RnecService {
  tiposDeDocumentosValidosParaConsultar: ListaTipoIdentificacion[] = [
    ListaTipoIdentificacion.CC,
    ListaTipoIdentificacion.RC,
    ListaTipoIdentificacion.TI
  ];

  constructor(private httpService: HttpService) { }

  consultar(body: IdentidadPersonaDto): Observable<GeneralResponse<RnecResponseDto>> {
    return this.httpService.post<any>(
      environment.RNEC_API.PREFIJO_URL,
      '',
      body
    ).pipe(
      map(response => {
        const body = response.body || {};

        const rnec = new RnecResponseDto(
          body.ivi,
          body.mensaje,
          body.validacion ?? false,
          body.soporteDigital ?? null,
          body.soporteParentesco ?? null,
          body.relacionParentesco ?? null
        );

        return CGeneralResponse.generalResponseDesdeObj<RnecResponseDto>(response, rnec);
      })
    );
  }

  validarHijo(detalleAfiliadoHijo: DetalleAfiliadoHijo): Observable<GeneralResponse<RnecResponseDto>> {
    return this.httpService.post<any>(
      environment.RNEC_API.PREFIJO_URL,
      environment.RNEC_API.VALIDAR_HIJO,
      detalleAfiliadoHijo
    ).pipe(
      map(response => {
        const body = response.body || {};

        const rnecHijo = new RnecResponseDto(
          body.ivi,
          body.mensaje,
          body.validacion ?? false,
          body.soporteDigital ?? null,
          body.soporteParentesco ?? null,
          body.relacionParentesco ?? null
        );

        return CGeneralResponse.generalResponseDesdeObj<RnecResponseDto>(response, rnecHijo);
      })
    );
  }

  obtenerDocumentoDtoRNEC(numeroDocumento: string) {
    const documentoRNEC: Documents = {
      documentoPropietario: numeroDocumento,
      idTipoDocumento: "16",
      name: "soporte_digital_RNEC.pdf",
      description: "Soporte Consulta RNEC",
      digitalSupport: false,
      id: 16,
      idTipoDocumentoDigital: "16",
      requiredValidation: false,
      idForm: 'rnec'
    };
    return documentoRNEC;
  }

  esIdentidadValidadaExitosamente(codigoIvi: IVI) {
    return codigoIvi == IVI.IVE;
  }

  esTipoDocumentoParaConsultar(codigo: string): boolean {
    if (!environment.FEATURE_FLAGS.RNEC) return false;

    return this.tiposDeDocumentosValidosParaConsultar.some(
      (documento) => documento.codigo === codigo
    );
  }
}
